// The message endpoints accept only OGG/Opus or WebM/Opus audio.
export const VOICE_MESSAGE_FILE_ACCEPT =
  'audio/ogg,audio/webm,.ogg,.oga,.opus,.webm';

const SUPPORTED_MIME_TYPES = ['audio/ogg', 'audio/webm', 'audio/opus'];
const SUPPORTED_EXTENSIONS = ['ogg', 'oga', 'opus', 'webm'];

export const isVoiceMessageFile = (file: File): boolean => {
  const mimeType = file.type.split(';')[0]?.trim().toLowerCase() ?? '';
  if (mimeType) {
    return SUPPORTED_MIME_TYPES.includes(mimeType);
  }

  // Some browsers report no type for .opus files.
  const extension = file.name.split('.').pop()?.toLowerCase() ?? '';
  return SUPPORTED_EXTENSIONS.includes(extension);
};
